<template>
  <b-container fluid>
    <loading :active.sync="isLoading" color="#00AB63"></loading>
    <b-row>
      <b-col sm="8">
        <div class="my-3 p-3 bg-white rounded shadow-sm"> 
          <h4 class="border-bottom border-gray pb-2 mb-0">Registrar nuevo empleado</h4>
          <div class="media text-muted pt-3">
            <b-form @submit.prevent="registrar()" v-if="show" style="width: 100%;">
              <b-row>
                <b-col>
                  <label>Nombre</label>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <b-form-input
                      v-model="form.firstname"
                      type="text"
                      required
                      placeholder="Nombre"
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <b-form-input
                      v-model="form.lastname"
                      type="text"
                      required
                      placeholder="Apellidos"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <label>Contraseña</label>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6">
                  <b-form-group>
                    <b-form-input
                      v-model="form.password"
                      type="password"
                      required
                      placeholder="Contraseña"
                      minlength="6"
                    />
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group>
                    <b-form-input
                      v-model="form.passwordRepeat"
                      type="password"
                      required
                      placeholder="Confirmar contraseña"
                      minlength="6"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              
              <b-row>
                <b-col sm="6">
                  <b-form-group label="Correo electrónico" label-for="input-1">
                    <b-form-input
                      v-model="form.email"
                      type="email"
                      required
                      placeholder="Correo electrónico"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Teléfono" label-for="input-1">
                    <b-form-input
                      v-model="form.phoneNumber"
                      type="tel"
                      required
                      placeholder="Teléfono"  
                    />
                  </b-form-group> 
                </b-col> 
              </b-row> 
              <b-row>
                <b-col sm="6">
                  <b-form-group label="Tipo de empleado" label-for="input-3">
                    <b-form-select v-model="form.rol" :options="roles" required></b-form-select>
                  </b-form-group>
                </b-col> 
                <b-col sm="6" v-if="form.rol == 'Supervisor' || esAdministrador()">
                  <b-form-group label="Empresa" label-for="input-3">
                    <b-form-select v-model="form.company" :options="companies" required></b-form-select>
                  </b-form-group>
                </b-col> 
              </b-row>
              <b-row>
                <b-col>
                  <b-button class="float-right boton_createch" type="submit" variant="primary">
                    <i class="far fa-save"></i> Registrar
                  </b-button>
                  <!-- <b-button type="reset" variant="danger">Resetear</b-button> -->
                </b-col>
              </b-row>
            </b-form>
          </div>
        </div>
      </b-col>
      <b-col sm="4">
        <Ultimos />
      </b-col>
    </b-row>
    <b-row>
      <b-col> 
        <div class="my-3 p-3 bg-white rounded shadow-sm">
          <h4 class="border-bottom border-gray pb-2 mb-0">Empleados registrados</h4>
          <div class="media text-muted pt-3">
            <b-container fluid>
              <!-- User Interface controls -->
              <b-row class="mb-4">
                <b-col sm="10">
                  <b-form-group label="Buscar" label-for="filterInput" class="mb-0">
                    <b-input-group size="sm">
                      <b-form-input v-model="filter" type="search" placeholder="Palabra a buscar"></b-form-input>
                      <b-input-group-append>
                        <b-button :disabled="!filter" class="boton_createch" @click="filter = ''">Borrar</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col sm="2">
                  <b-form-group label="Por Pagina" label-for="perPageSelect" class="mb-0">
                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- Main table element -->
              <b-table
                show-empty
                small
                stacked="md"
                :items="usuarios"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"
              >
                <template v-slot:cell(name)="row">{{ row.value.first }} {{ row.value.last }}</template>

                <template v-slot:cell(actions)="row">
                  <div class="float-right">
                    <b-button size="sm" @click="view(row.item._id)" class="mr-1 btn_editar">
                      <i class="far fa-eye"></i>
                    </b-button>
                    <b-button 
                      size="sm"
                      @click="editar(row.item, row.index, $event.target)"
                      class="mr-1 btn_editar"
                    >
                      <i class="far fa-edit"></i>
                    </b-button>
                    <b-button 
                      size="sm"
                      @click="eliminar(row.item, row.index, $event.target)"
                      class="mr-1 btn_borrar"
                    >
                      <i class="far fa-trash-alt"></i>
                    </b-button>
                  </div>
                </template>

                <template v-slot:row-details="row">
                  <b-card>
                    <ul>
                      <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                    </ul>
                  </b-card>
                </template>
              </b-table>
              <b-container>
                <b-row class="justify-content-end">
                  <b-col sm="5">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      align="fill"
                      size="sm"
                      class="my-0"
                    ></b-pagination>
                  </b-col>
                </b-row>
              </b-container>

              <!-- Delete modal -->
              <b-modal
                :id="deleteModal.id"
                :title="deleteModal.title"
                @ok="eliminarEmpleado(deleteModal.eliminar)"
                centered 
                ok-title="Eliminar"
                cancel-title="Cancelar"
              >
                <p
                  style="text-align:center; font-size:25px; font-weight:bold;"
                >¿Está seguro que desea eliminar?</p>
              </b-modal>
              <!-- Editar modal -->
              <b-modal :id="editModal.id" size="lg" :title="editModal.title" centered hide-footer>
                <b-container>
                  <b-row>
                    <b-form @submit.prevent="actualizar()" v-if="show" style="width: 100%;">
                      <b-row>
                        <b-col sm="6">
                          <b-form-group label="Nombre">
                            <b-form-input
                              v-model="editModal.new.firstname"
                              type="text"
                              required
                              placeholder="Nombre"
                              tabindex="1"
                            />
                          </b-form-group>
                          <b-form-group label="Correo electronico">
                            <b-form-input
                              v-model="editModal.new.email"
                              type="email"
                              required
                              placeholder="Correo electronico"
                              tabindex="3"
                            />
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <b-form-group label="Apellidos">
                            <b-form-input
                              v-model="editModal.new.lastname"
                              type="text"
                              required
                              placeholder="Apellidos"
                              tabindex="2"
                            />
                          </b-form-group>
                          <b-form-group label="Tipo de empleado">
                            <b-form-select
                              v-model="editModal.new.rol"
                              :options="roles"
                              required
                              tabindex="4"
                            ></b-form-select>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col>
                          <label>Cambiar contraseña actual (Opcional)</label>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="6">
                          <b-form-group>
                            <b-form-input
                              type="password"
                              placeholder="Nueva contraseña"
                              v-model="editModal.new.newPassword"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col sm="6">
                          <b-form-group>
                            <b-form-input
                              type="password"
                              placeholder="Confirmar nueva contraseña"
                              :required="this.editModal.setPassword"
                              v-model="editModal.new.passwordRepeat"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                      <hr />
                      <b-row>
                        <b-col>
                          <div class="float-right">
                            <b-button
                              variant="secondary"
                              size="sm"
                              class="mr-1"
                              @click="ocultaModal(editModal.id)"
                            >Cancelar</b-button>
                            <b-button
                              type="submit"
                              variant="primary"
                              size="sm"
                              :disabled="editModal.disableBtn"
                            >Editar</b-button>
                          </div>
                        </b-col>
                      </b-row>
                    </b-form>
                  </b-row>
                </b-container>
              </b-modal>
            </b-container> 
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Ultimos from "@/components/Empleados/Ultimos.vue";
import axios from "axios";
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  components: {
    Ultimos,
    Loading
  },
  data() {
    return {
      isLoading: false,
      form: {
        firstname: "",
        lastname: "",
        password: "",
        passwordRepeat: "",
        email: "",
        phoneNumber: null,
        company: null,
        rol: null
      },
      roles: [{ text: "Selecciona rol de usuario", value: null }], 
      show: true,
      usuarios: [],
      companies: [{ text: "Selecciona la empresa", value: null }],
      fields: [
        { key: "firstname", sortable: true, label: "Nombre" },
        { key: "lastname", sortable: true, label: "Apellido" },
        { key: "email", sortable: true, label: "Correo electronico" },
        {
          key: "rol",
          sortable: true,
          label: "Tipo de empleado",
          filterByFormatted: true
        },
        { key: "salesmans", sortable: true, label: "Vendedores" },
        { key: "customers", sortable: true, label: "Clientes" },
        { key: "actions", label: "" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      filter: null,
      filterOn: [],
      deleteModal: {
        id: "info-modal",
        title: "",
        eliminar: null
      },
      editModal: {
        id: "edit-modal",
        title: "",
        new: { newPassword: "", passwordRepeat: "" },
        setPassword: false
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  watch: {
    "editModal.new.newPassword": function(newValue, old) {
      if (newValue.length > 0) {
        this.editModal.setPassword = true;
      } else {
        this.editModal.setPassword = false;
      }
    }
  },
  created() {
    if (this.$store.state.usuario.rol == "Supervisor") {
      this.roles.push({ text: "Vendedor", value: "Vendedor" });
    } else {
      this.roles.push({ text: "Administrador", value: "Administrador" });
      this.roles.push({ text: "Supervisor", value: "Supervisor" });
      this.roles.push({ text: "Vendedor", value: "Vendedor" });
    }
    this.listar();
     if(this.$store.state.usuario.rol == "Administrador"){
      this.get_companies(); 
    }  
  },
  methods: {
    eliminarEmpleado() {
      this.isLoading = true;
      axios
   
        .delete(`user/${this.deleteModal.eliminar}`)
        .then(res => {
              console.log(this.deleteModal.eliminar);
          this.listar();
          this.isLoading = false;
        })
        .catch(error => {});
    },
    actualizar() { 
      this.isLoading = true; 
      if (this.editModal.new.newPassword.length > 0) { 
        if ( this.editModal.new.newPassword === this.editModal.new.passwordRepeat ) { 
          axios
            .put("user/" + this.editModal.new._id, {
              firstname: this.editModal.new.firstname,
              lastname: this.editModal.new.lastname,
              email: this.editModal.new.email,
              rol: this.editModal.new.rol,
              password: this.editModal.new.newPassword
            })
            .then(res => {
              this.listar();
              this.ocultaModal(this.editModal.id);
              this.isLoading = false;
            })
            .catch(error => {});
        } else {
          this.makeToast("Las contraseñas no coinciden.", "Editar usuario.");
        }
      } else {
        this.isLoading = true; 
        axios
          .put(`user/${this.editModal.new._id}`, {
            firstname: this.editModal.new.firstname,
            lastname: this.editModal.new.lastname,
            email: this.editModal.new.email,
            rol: this.editModal.new.rol
          })
          .then(res => {
            if (res.status === 202) {
              this.makeToast(
                "Ya existe una usuario con ese correo electrónico.",
                "Editar usuario."
              );
              this.isLoading = false;
            } else {
              this.listar();
              this.ocultaModal(this.editModal.id);
              this.isLoading = false;
            }
          })
          .catch(error => {});
      }
    },
    view(iduser) {
      this.$router.replace({ name: "empleados_id", params: { id: iduser } });
    },
    eliminar(item, button) {
      this.deleteModal.eliminar = item._id;
      this.deleteModal.title = `Eliminar empleado: ${item.firstname} ${item.lastname}`;
      this.$root.$emit("bv::show::modal", this.deleteModal.id, button);
    },
    editar(item, index, button) {
      this.resetModal();
      this.editModal.new.firstname = item.firstname;
      this.editModal.new.lastname = item.lastname;
      this.editModal.new.email = item.email;
      this.editModal.new._id = item._id;
      this.editModal.new.rol = item.rol;
      this.editModal.new.newPassword = "";
      this.editModal.new.passwordRepeat = "";
      this.editModal.title = `Editar empleado: ${item.firstname} ${item.lastname}`;
      this.$root.$emit("bv::show::modal", this.editModal.id, button);
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    listar() {
      let me = this; 
      this.isLoading = true; 
      axios
        .get("users/" + this.$store.state.usuario._id+'/status=true')
        .then(res => {   
            me.totalRows = res.data.length;
            me.usuarios = res.data;   
        })
        .then( res => {
          this.isLoading = false;
        })
        .catch(error => {});
    },
    get_companies() {
      this.isLoading = true;
      var companies_temp = null;
      axios
        .get("companies")
        .then(res => { 
          if (res.data) {  
            companies_temp = res.data;
            console.log(companies_temp);
          }
          for (let index = 0; index < companies_temp.length; index++) {
            this.companies.push({ text: companies_temp[index].name, value: companies_temp[index]._id });  
          }
          this.isLoading = false;
        })
        .catch(error => {
          this.isLoading = false;
          this.makeToast(
            "Ocurrió un error inesperado al consultar las empresas existentes.",
            "Error"
          );
        });
    },
    registrar() { 
      this.isLoading = true;
      if (this.form.password === this.form.passwordRepeat) {
        if (this.$store.state.usuario.rol == "Administrador") { 
          var usuario_temp = {
              firstname: this.form.firstname,
              lastname: this.form.lastname,
              password: this.form.password,
              email: this.form.email,
              rol: this.form.rol,
              phoneNumber: this.form.phoneNumber,
              company: this.form.company
          }
        } else {
          var usuario_temp = {
              firstname: this.form.firstname,
              lastname: this.form.lastname,
              password: this.form.password,
              email: this.form.email,
              rol: this.form.rol,
              phoneNumber: this.form.phoneNumber
          }
        } 
        axios
          .post("user", {
            id_creador: this.$store.state.usuario._id, 
            usuario: usuario_temp
          })
          .then(res => {
            if (res.status === 202) {
              this.makeToast(
                "Ya existe un usuario con ese email.",
                "Usuarios."
              );
              this.isLoading = false;
            } else {
              this.form.firstname = "";
              this.form.lastname = "";
              this.form.password = "";
              this.form.passwordRepeat = "";
              this.form.email = "";
              this.form.rol = null;
              this.form.company = null;
              this.form.phoneNumber = null;
              this.listar();
              this.isLoading = false;
            }
            console.log(usuario_temp);
          })
          .catch(error => {
            this.makeToast("Ocurrió un error inesperado.", "Usuarios.");
          });
      } else {
        this.makeToast("Las contraseñas no coinciden.", "Usuarios.");
      }
    },
    ocultaModal(id) {
      this.$bvModal.hide(id);
    },
    resetModal() {
      this.editModal.new = {
        firstname: "",
        lastname: "",
        email: "",
        _id: "",
        rol: "",
        newPassword: "",
        passwordRepeat: ""
      };
      this.editModal.setPassword = false;
    }
  }
};
</script>
 